module.exports = __webpack_public_path__ + "static/img/Tax_Invoice.7f95c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/receipts/Tax_Invoice.png
// module id = VOsV
// module chunks = 150